/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ReleaseStateEnum = 'LOADED' | 'DEFAULT' | 'AVAILABLE' | 'OBSOLETE';

export const ReleaseStateEnum = {

    LOADED: 'LOADED' as ReleaseStateEnum,

    DEFAULT: 'DEFAULT' as ReleaseStateEnum,

    AVAILABLE: 'AVAILABLE' as ReleaseStateEnum,

    OBSOLETE: 'OBSOLETE' as ReleaseStateEnum
};

